var url = process.env.API_URL + process.env.API_VERSION;
import axios from 'axios';
import cookie from 'vue-cookie';
import router from '../../router';
const state  = {
  user: cookie.get('user') || {},
  token: cookie.get('user-token') || null,
  counselor_info: {},
  user_info: {},
  // counselor_clone: {},
  message: '',
  status: 'validate',
  status_code: '',
  show_loading_api: false
}

const mutations = {
  SET_DATA_USER(state, user){
    if(user == {} || user == undefined){
      cookie.delete('user')
    }else{
      cookie.set('user', JSON.stringify(user), {expires: 7})
    }
    state.user = user;
  },
  SET_MESSAGE(state, message){
    state.message = message;
  },
  SET_STATUS_CODE(state, status_code){
    state.status_code = status_code;
  },
  SET_STATUS(state, status){
    state.status = status
  },
  SET_TOKEN(state, token){
    cookie.set('user-token', token, {expires: 7})
    state.token = token
  },
  REMOVE_TOKEN(state){
    cookie.delete('user-token')
    state.token = null
  }, 
  set_info_counselor(state, counselor){
    state.counselor_info = counselor
  },
  set_user_info(state, user_detail){
    var score_field = ['ielts', 'toefl', 'toeic', 'sat', 'act', 'gmat', 'gre']
    score_field.forEach((sc) =>{
      if (user_detail.score[sc] == undefined) {
        user_detail.score[sc] = ''
      }
    })
    state.user_info  = user_detail
  },
  set_show_loading_api(state, value){
    state.show_loading_api = value
  }
  // duplicate_counselor_dât(state)Ơ
  //   console.log(state.counselor_info)
  //   state.counselor_clone = state.counselor_info
  // Ư
}

const actions = {
  sign_up({commit}, data) {
    axios.post(url + '/users/sign_up',
      data,
      { headers: 
        { 
          'Access-Control-Allow-Origin': '*',
          'Content-type': 'application/json'           
        } 
      })
      .then((response) =>{
        commit('SET_DATA_USER', response.data.extra.user)
        commit('SET_MESSAGE', response.data.message)
        commit('SET_STATUS_CODE', response.data.status)
        router.push('/login')
      })
      .catch((error) => {
        commit('SET_MESSAGE', error.response.data.message)
        commit('SET_STATUS_CODE', error.response.status)
      })
  },
  sign_up_without_password({commit}, data){
    commit('set_show_loading_api', true)
    axios.post(url+ '/users/sign_up',data,
      { headers: 
        { 
          'Access-Control-Allow-Origin': '*',
          'Content-type': 'application/json'           
        } 
      })
      .then((response) => {
        commit('set_show_loading_api', false)
        alert("Bạn đã tạo tài khoản thành công. Kiểm tra hòm thư email để biết thông tin tài khoản")
        router.push('/login')
      })
      .catch((error) => {
        commit('set_show_loading_api', false)
        if (error.response != undefined){
          alert(error.response.data.message)
        }else{
          alert("Có lỗi trong quá trình tạo tài khoản")
        }
      })
  },

  login({commit}, data){
    axios.post(url + '/users/sign_in',
      data,
      { headers:
        {
          'Access-Control-Allow-Origin': '*',
          'Content-type': 'application/json'
        }
      })
      .then((response) => {
        // commit('SET_MESSAGE', response.data.message)
        commit('SET_DATA_USER', response.data.extra)  
        commit('SET_TOKEN', response.data.extra.auth_token)
        axios.defaults.headers.common['Authorization'] = response.data.extra.auth_token        
        router.push('/')
        router.go('')

      })
      .catch((error) => {
        if (error.response != undefined){
          commit('SET_MESSAGE', error.response.data.message)
          commit('SET_STATUS_CODE', error.response.status)
        }                
        commit('SET_DATA_USER', {})
        commit('REMOVE_TOKEN')
      })
  },

  logout({commit}){
    var token = cookie.get('user-token') || ''
    commit('REMOVE_TOKEN')
    commit('SET_DATA_USER', {})
    delete axios.defaults.headers.common['Authorization'];
    axios.post(url + '/users/logout',{},
    {
      headers:
      {
        'Access-Control-Allow-Origin': '*',
        'Content-type': 'application/json',
        'Authorization': token
      }
    })
    .then((response) => {      
      alert('Đăng xuất thành công')
      router.push('/')
      // router.go() 
    })
    .catch((errors) => {
      if (errors.response != undefined){
        // alert(errors.response.data.message)
      }else{
        // aler('Có lỗi xảy ra') 
      }
    })    
  },

  set_status({commit}, status){
    commit('SET_STATUS', status)
  },
  set_message({commit}, message){
    commit('SET_MESSAGE', message)
  },

  get_counselor_info({commit}, id){
    axios.get(url + '/users/counselor?id=' + id,
      {
        // Cần token khi muốn lấy thông tin để edit user
        // Chỉ edit được khi là admin hoặc chính người đó
        headers: {
          'Authorization': cookie.get('user-token') || ''
        }
      })
      .then((response) =>{
        commit('set_info_counselor', response.data.extra.counselor)
        // commit('duplicate_counselor_data')
      })        
      .catch((error) =>{
        commit('set_info_counselor', {})
        // commit('duplicate_counselor_data')
      });    
  },

  get_user_info({commit}, id){
    axios.get(url + '/users/user_detail?id=' + id,
    {
      headers: {
        'Authorization': cookie.get('user-token') || ''
      }
    })
    .then((response) => {
      commit('set_user_info', response.data.extra.user_detail)
    })
    .catch((error) => {
      commit('set_user_info', {})
    })
  },

  update_user({commit}, data){
    var id = data['id']
    delete data['id']
    delete data['avatar']
    axios.post(url+ '/users/update_user',
      {
        'id': id,
        data_update: data
      },
      {
        headers:{
          'Authorization': cookie.get('user-token') || ''
        }
      })
      .then((response) =>{
        alert('Cập nhật thành công');
        var link = '/counselor?id=' + id
        router.push(link)
        // this.store.dispatch('get_counselor_info',id)

      })
      .catch((error) => {
        if (error.response != undefined){
          alert(error.response.data.message)
        }else{console.log(error)}        
        
      })
  },

  reset_password_api({commit}, data){
    axios.post(url + '/users/change_password',
      data,
      {
        headers:
        {
          'Authorization': cookie.get('user-token') || '',
          'Access-Control-Allow-Origin': '*',
          'Content-type': 'application/json'
        }
      })
      .then((response)=> {
        alert('Đổi mật khẩu thành công')
        router.push('/login')
      })
      .catch((error) => {
        if(error.response != undefined){
          alert(error.response.data.message)
        }else{
          alert('Đổi mật khẩu không thành công')  
        }
      })
  },

  forgot_password_api({commit}, data){
    axios.post(url + '/users/forgot_password', data)
    .then((response) => {
      alert('Email khôi phục mật khẩu đã được gửi đi')
      router.push('/login')
    })
    .catch((error) => {
      if(error.response != undefined){
        alert(error.response.data.message)
      }else{
        alert('Khôi phục mật khẩu thất bại')
      }
    })
  }
}

const getters = {
  isAuthenticated: state => {
    return state.token    
  },
  getUser: state => state.user,
  authStatus: state => state.status
}
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js